const base_url = 'https://diazapps.com/public_diazappsnfts/api'
/* const base_url = 'http://localhost:8000/api' */

export default base_url